import React from 'react'
import _ from 'lodash'
import {connect, shallowEqual, useSelector} from 'react-redux'
import {config, refresh} from '../../../config/config'
import { WidgetGrid, JarvisWidget } from '../../../common';
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import {useHistory} from "react-router-dom";



function CaseDetails(props) {
    const id = props.match.params.id;
    const delId = props.match.params.del_index;
    const url = config.iframeServer + "cases/open?APP_UID="+id+"&DEL_INDEX="+delId + "&sid=" + localStorage.getItem('session_id');
    const loadCompleted = (t,e) => {
    }

    return (
            <div style={{height:"100%"}}>
                <iframe
                    sandbox="allow-downloads allow-top-navigation allow-same-origin allow-scripts
                  allow-forms allow-modals allow-popups allow-top-navigation allow-pointer-lock "
                    style={{width:"100%",height:"100vh",minHeight: "200px",border: "0"}}
                    src={url}
                    onLoad={(t,e) => loadCompleted(t,e)}
                > </iframe>
            </div>)
}


export default connect((state)=>(state.newInbox))(CaseDetails)